<template>
  <div class="bun-container">
    <div class="bun__aligner" v-if="loading">
      <LoaderImg></LoaderImg>
    </div>
    <div class="bun__aligner" v-else-if="error">
      <img :src="errorImage">
    </div>
    <div class="bun__aligner" v-else>
      <div class="bun-base bun-image">
        <img :src="bunImage"/>
      </div>
      <div class="bun-layer-seeding bun-image" v-if="curRecipe.seeding.key !== undefined">
        <img :src="seedingImage"/>
      </div>
      <div class="bun-layer-surface bun-image" v-if="curRecipe.surface.key !== undefined">
        <img :src="surfaceImage"/>
      </div>
      <div class="bun-label" v-if="curRecipe.label.id !== undefined">
        <img :src="labelImage"/>
      </div>
      <emoji-canvas/>
    </div>
  </div>
</template>

<script>
import Bun from './Bun'

export default {
  name: 'ShareBun',
  extends: Bun,
  computed: {}
}
</script>
